/*
 * JSOC shim for Dawn 16's standard-events module (#46, review finding F4).
 *
 * assets/cart.js line 15 does, at PARSE time and unguarded:
 *     class CartItems extends window.StandardEvents.createViewEventElement(HTMLElement)
 * Every later use in that file is guarded with `window.StandardEvents || {}`, so this one line is
 * the single point where a failed CDN import takes the cart page down: `cart-items` is never
 * defined and quantity and remove stop working.
 *
 * Two properties matter, and both were review findings rather than afterthoughts:
 *
 * 1. ASSIGN CONDITIONALLY. theme.liquid imports the real module and assigns window.StandardEvents
 *    wholesale. A shim that assigned unconditionally would replace the real namespace on every
 *    page, leaving every guarded consumer silently inert while the obvious test still passed. This
 *    file therefore only fills a gap, and is loaded BEFORE that module so the real one always wins.
 *
 * 2. EXPOSE A NO-OP connectedCallback(). cart.js:36 calls super.connectedCallback() and registers
 *    its cart-update subscription immediately after. A naive `(Base) => Base` shim leaves that call
 *    undefined, it throws, and the subscription never registers — yet quantity and remove keep
 *    working, because their listener is added in the constructor. The cart would then stop
 *    reacting to any external update while every check stayed green.
 */
(function () {
  if (window.StandardEvents && typeof window.StandardEvents.createViewEventElement === 'function') return;

  var existing = window.StandardEvents || {};
  existing.createViewEventElement = existing.createViewEventElement || function (Base) {
    var Klass = Base || HTMLElement;
    return class extends Klass {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
      }
    };
  };
  window.StandardEvents = existing;
})();
